import React from 'react';
import styled from 'styled-components';
import { Button as MUIButton, ButtonProps, IconProps } from '@material-ui/core';

interface IProps extends ButtonProps {
    cancel?: boolean;
    icon?: IconProps;
    loading?: boolean;
}

const BaseButtonLink: React.FC<IProps> = ({
    cancel,
    children,
    icon,
    loading,
    ...other
}) => (
    <MUIButton disableRipple disabled={loading} {...other}>
        {icon} {children}
    </MUIButton>
);

export const ButtonLink = styled(BaseButtonLink)`
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    color: ${({ theme, cancel }) =>
        cancel ? theme.palette.error.main : theme.palette.primary.main};
    font-size: ${({ theme }) => theme.typography.body1.fontSize};
    text-transform: none;
    border-radius: 0;
    background: none;
    padding: 0;
    text-align: left;

    .MuiButton-label {
        font-weight: 700;
    }

    :hover {
        background: none;
        text-decoration: underline;
    }

    :disabled {
        background-color: ${({ theme }) => theme.palette.action.disabled};
        color: ${({ theme }) => theme.palette.background.paper};
    }

    .MuiSvgIcon-root {
        position: relative;
        top: -2px;
        font-size: ${({ theme }) => theme.typography.body1.fontSize};
        margin-right: ${({ theme }) => `${theme.spacing(2)}px`};
    }
`;
